import {
  PerkSectionsDataItemsResultTypenames,
  Query,
  SectionItems,
  VendorItem,
} from '@varo/graphql-schema-types';
import { REWARDS_HOME } from 'features/rewards/RewardsHome/RewardsHome.constants';
import getPerkSectionsV2 from 'services/graphql/queries/rewards/GetPerkSectionsV2';
import { useQuery } from 'urql';

export const useStandardOffers = (
  selectedCategoryId: string | null,
  coords: { latitude: number; longitude: number } | null,
  hidePills: boolean,
): VendorItem[] | null => {
  const coordinateInput = coords
    ? {
        latitude: coords.latitude,
        longitude: coords.longitude,
      }
    : null;

  const [{ data: perksData }] = useQuery<Query>({
    query: getPerkSectionsV2,
    variables: {
      first: REWARDS_HOME.first,
      after: '',
      ...(coordinateInput && {
        input: {
          coordinate: coordinateInput,
        },
        promoSectionInput: {
          coordinate: coordinateInput,
        },
      }),
    },
    requestPolicy: 'cache-only',
    pause: !hidePills,
  });

  if (!hidePills || !perksData) {
    return null;
  }

  const edges = perksData.myPartnerOffers?.perkSections?.edges ?? [];
  const section = edges.find(
    (edge) => edge.node.id === selectedCategoryId,
  )?.node;

  if (section && section.itemsV2) {
    const validItems = section.itemsV2.filter(
      (item): item is SectionItems =>
        item.__typename === PerkSectionsDataItemsResultTypenames.SectionItems,
    );

    return validItems.map(
      (item): VendorItem => ({
        __typename: 'VendorItem',
        id: item.id ?? '',
        name: item.title ?? '',
        merchantId: item.merchantId,
        offerSource: item.offerSource,
        cashbackRateFormatted: item.subTitle || item.cashback || '',
        cashbackValue: item.cashback || '',
        distanceFormatted: item.distanceText,
        logoUrl: item.logoImage,
        isActive: item.isActivated ?? false,
        location: item.location
          ? {
              __typename: 'GeoCoordinate',
              latitude: item.location.latitude,
              longitude: item.location.longitude,
            }
          : null,
        tag: item.tag,
        tertiary: item.timeRemaining,
        onClick: {
          __typename: 'RouteNavigationAction',
          route: '',
          analyticsEvent: item.onClick?.analyticsEvent ?? null,
        },
        address: null,
        pricingTier: null,
        label: null,
        marker: null,
        activatedDuration: null,
      }),
    );
  }

  return null;
};
